import { push } from 'react-router-redux';
import actions from '../actions';
import { put, call, takeEvery, select } from 'redux-saga/effects'
import * as emailEnterpriseMapApis from '../apis/emailEnterpriseMapApis';

function* getEmailEnterpriseMap(action) {
    const state = yield select();
    const token = state.userAccount.token;
    try {
        let emailEnterpriseMap = yield call(emailEnterpriseMapApis.getEmailEnterpriseMapApi, token);
        yield put({type: actions.GET_EMAIL_ENTERPRISE_MAP_SUCCESS, emailEnterpriseMap});
    } catch(err) {
        console.log("Failed to get emailEnterpriseMap ", err);
        yield put({type: actions.GET_EMAIL_ENTERPRISE_MAP_FAILED, errorMessage: err});
    }
}

function* saveEmailEnterprisesMap(action) {
    const state = yield select();
    const token = state.userAccount.token;
    try {
        yield call(emailEnterpriseMapApis.saveEmailEnterpriseMapApi, token, action.mapList);
        yield put({type: actions.SAVE_EMAIL_ENTERPRISE_MAP_SUCCESS, mapList: action.mapList});
    } catch(err) {
        console.log("Failed to save emailEnterpriseMap ", err);
        yield put({type: actions.SAVE_EMAIL_ENTERPRISE_MAP_FAILED, errorMessage: err});
    }
}

const expertsSagas = [
    takeEvery(actions.GET_EMAIL_ENTERPRISE_MAP_REQUEST, getEmailEnterpriseMap),
    takeEvery(actions.SAVE_EMAIL_ENTERPRISE_MAP_REQUEST, saveEmailEnterprisesMap)
]
export default expertsSagas;


// WEBPACK FOOTER //
// ./src/sagas/emailEnterpriseMapSagas.js